import React, { useEffect, useState } from 'react';
import Nav from '../landing/nav';
import ReloadWarning from '../popup/reloadwarning';
import InstructionsModal from '../popup/InstructionsModal';

const ElectionForm = ({ isActive }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showWarning, setShowWarning] = useState(false);
    const [navigateAway, setNavigateAway] = useState(false);
    const [isInstructionsOpen, setIsInstructionsOpen] = useState(true);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    useEffect(() => {
        const handleFormSubmission = (event) => {
            if (event.origin === 'https://docs.google.com') {
                window.location.reload();
            }
        };

        window.addEventListener('message', handleFormSubmission);

        const disableShortcuts = (e) => {
            if (e.keyCode === 123 || 
                (e.ctrlKey && e.shiftKey && e.keyCode === 73) || 
                (e.ctrlKey && e.shiftKey && e.keyCode === 74) || 
                (e.ctrlKey && e.keyCode === 85)) {
                e.preventDefault();
            }
        };
        document.addEventListener('keydown', disableShortcuts);

        const handleBeforeUnload = (e) => {
            if (isActive) {
                e.preventDefault();
                e.returnValue = ''; 
                setShowWarning(true);
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('message', handleFormSubmission);
            document.removeEventListener('keydown', disableShortcuts);
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [navigateAway, isActive]);

    const handleStay = () => setShowWarning(false);
    const handleLeave = () => {
        setNavigateAway(true);
        window.history.back();
    };

    // Use 'hidden' class to keep the iframe mounted but invisible
    return (
        <div className={`bg-slate-50 min-h-screen ${isActive ? 'block' : 'hidden'}`}>
            <Nav menuOpen={menuOpen} toggleMenu={toggleMenu} />
            <div style={{ paddingTop: '110px' }} className="pb-12 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <header className="flex justify-between items-center mb-8">
                    <div>
                        <h1 className="text-3xl font-black tracking-tight text-slate-950">Election Return Form</h1>
                        <p className="mt-1 text-lg text-slate-800 font-bold">Please fill out the form embedded below carefully.</p>
                    </div>
                    <button 
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg transition-all shadow-md"
                        onClick={() => setIsInstructionsOpen(true)}
                    >
                        Show Instructions
                    </button>
                </header>

                <div className="bg-white rounded-xl shadow-2xl p-2 border border-slate-200">
                    <div className="relative h-[80vh]">
                        <iframe
                            id="election-form-iframe"
                            src={process.env.REACT_APP_GOOGLE_FORM_URL}
                            title="Election Return Form"
                            className="w-full h-full rounded-lg"
                            frameBorder="0"
                            sandbox="allow-same-origin allow-scripts allow-forms"
                        >
                            Loading…
                        </iframe>
                    </div>
                </div>
            </div>

            {showWarning && (
                <ReloadWarning 
                    isOpen={showWarning} 
                    onStay={handleStay} 
                    onLeave={handleLeave} 
                />
            )}
            <InstructionsModal isOpen={isInstructionsOpen} onClose={() => setIsInstructionsOpen(false)} />
        </div>
    );
};

export default ElectionForm;